import React, { useMemo } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { useGetAllModelDropdownListQuery } from '../../../../../../api';

/**
 * Ödeme modalı için model çoklu seçim.
 * Ortak ModelMultiSelectDropdown'a dokunulmaz; GetModelDropdown sözleşmesi
 * brandName string (BrandShort, örn. "KARSAN") bekler.
 */
const resolveBrandName = (brand) => {
    if (!brand) return '';
    if (typeof brand === 'string') return brand;
    if (typeof brand === 'object') {
        return brand.brandShort || brand.brand || brand.name || brand.displayValue || '';
    }
    return '';
};

const PaymentModelMultiSelect = ({ value = [], onChange, brand, className = '', disabled = false, placeholder = 'Model seçiniz' }) => {
    const brandName = resolveBrandName(brand);

    const { data: modelData = [], isLoading } = useGetAllModelDropdownListQuery({
        productGroup: '',
        brandName,
        modelName: ''
    });

    const modelOptions = useMemo(
        () =>
            (Array.isArray(modelData) ? modelData : []).map((model) => ({
                id: model.id,
                name: model.model,
                displayValue: model.model
            })),
        [modelData]
    );

    const selectedOptions = useMemo(() => {
        if (!value || !Array.isArray(value) || value.length === 0) return [];
        return value.map((v) => modelOptions.find((opt) => opt.id === v.id) || { ...v, displayValue: v.displayValue ?? v.name ?? String(v.id) }).filter(Boolean);
    }, [value, modelOptions]);

    return (
        <MultiSelect
            value={selectedOptions}
            options={modelOptions}
            onChange={(e) => onChange(e.value)}
            optionLabel="displayValue"
            dataKey="id"
            filter
            showClear
            filterBy="id,name"
            className={className}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled}
            display="chip"
            virtualScrollerOptions={{ itemSize: 38 }}
            itemTemplate={(option) => (
                <div>
                    <span style={{ fontWeight: 'bold' }}>{option.id}</span> - {option.name}
                </div>
            )}
        />
    );
};

export default PaymentModelMultiSelect;
